<template>
    <dialogWrap
        v-model="show"
        title="开通支付宝支付"
        :width="'560px'"
    >
        <div class="title">开通支付宝支付前，请仔细阅读以下说明：</div>
        <div class="content">
            <div>
              1. 支付宝支付是基于支付宝能力开通的一款支持从司机个人支付宝账户中进行资金划扣的产品能力，对司机逾期未缴纳金额将自动发起划扣任务。 您点击【我已阅读，继续开通】则视为您同意平台对此能力提出的监管要求及使用标准。
            </div>
            <div>
                2. 平台将收取每笔划扣金额的<span class="highlight">{{ ruleConfig.commissionWithholdAlipay  }}%</span>作为技术服务费。
            </div>
            <div>
                3. 支付宝支付限额：单日限额<span class="highlight">{{ ruleConfig.onlineAliLimitDay }}</span>元，单月限额<span class="highlight">{{ ruleConfig.onlineAliLimitMonth }}</span>元。
            </div>

            <div>
                4. 司机咨询/投诉划扣金额的数量，近<span class="highlight">30</span>日内不能超过<span class="highlight">3</span>起，若高于此标准，则平台将直接收回支付宝支付能力，不予启用。
            </div>
        </div>
        <template slot="footer">
            <el-button @click="show = false">取消</el-button>
            <el-button type="primary" @click="agreeToContinueOpen">我已阅读，继续开通</el-button>
        </template>
    </dialogWrap>
</template>

<script setup>
import { getWithholdConfig } from '@/api/domain/finance'
import { ref } from 'vue'

const show = ref(false)
const rowData = ref(null)
const emit = defineEmits(['agreeToContinueOpen'])

const ruleConfig = ref({
  onlineAliChannelRate: '', // 代扣通道手续费
  commissionWithholdAlipay: '', // 代扣技术手续费
  onlineAliLimitSingle: '', // 单笔限额
  onlineAliLimitDay: '', // 单日限额
  onlineAliLimitMonth: '', // 单月限额
})

const showDialog = (row) => {
  rowData.value = row
  getWithholdRule()
  show.value = true
}

const getWithholdRule = async () => {
  const { code, data } = await getWithholdConfig({
    licenceNo: rowData.value.licenceNo,
  })
  if (code === 1 && data) {
    ruleConfig.value = data
  }
}

const agreeToContinueOpen = () => {
  show.value = false
  emit('agreeToContinueOpen', rowData.value)
}

defineExpose({
  showDialog,
})
</script>

<style lang="scss" scoped>
.title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 20px;
}
.content {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    .highlight {
        margin: 0 4px;
        font-weight: 500;
        color: red;
    }
}
</style>
